// Later can update the prod api and ui to the real domains,
// then in the package.json update the build and or start scripts (or add new ones) for debugging/deploying
// can set / use environment variables with process.envs
const Base = Object.freeze({
  devUi: 'http://localhost:3000',
  //devApi: 'https://api-gsareporting.plego.net',
  devApi: 'https://api.gsareporting.com',
  // devApiIISExpress: 'https://localhost:44328/'
  // devApi: 'https://localhost:7086'
  // devApi: 'https://api-gsareporting.plego.net',

  stagingApi: 'https://api-gsareporting.plego.net',
  stagingUi: 'https://graystone-dev-ui.iotestsite.com',

  prodApi: 'https://api.gsareporting.com',
  prodUi: 'https://gsareporting.com',
});
const SurveyPrints = Object.freeze({
  Update: '/SurveyPrint/update',
  UnUpdate: '/SurveyPrint/un-update',
  UpdateBatch: '/SurveyPrint/update-batch',
  UnUpdateBatch: '/SurveyPrint/un-update-batch',
  reportbuttonFile: '/Report/report-button-file',
  reportbuttonFileStatus: '/Report/report-button-file-status',
  SendRegEmailsButton: '/SurveyPrint/send-registration-emails',
  SendRegNumbers: '/SurveyPrint/send-registration-numbers',
});

const Arranger = Object.freeze({
  FULL_LIST: '/Arranger/list',
  LIST: '/Arranger/dropdown-list',
  GET_BY_CODE: '/Arranger/get-by-code',
  GET_BY_NAME: '/Arranger/get-by-name',
  ADD: '/Arranger/add',
  UPDATE: '/Arranger/update',
  DELETE: '/Arranger/delete',
  COMBINE: '/Arranger/combine/',
});

const Batch = Object.freeze({
  LIST: '/Batch/list',
  FetchBatch: '/Batch/',
  DELETEBATCH: '/Batch/delete/',
});

const BatchO = Object.freeze({
  LIST: '/BatchO/list',
  FetchBatch: '/BatchO/',
  DELETEBATCH: '/BatchO/delete/',
});

const Client = Object.freeze({
  LIST: '/Client/list',
  CLIENT: '/Client',
  GET_CODE: '/Client/get-by-code',
  GET_NAME: '/Client/get-by-name',
  ADD: '/Client/add',
  UPDATE: '/Client/update',
  DROPDOWN: '/Client/dropdown-list',
  SET_OVERRIDES: '/Client/set-report-overrides',
  EMAIL_LIST: '/clientemail/list-encrypted',
  EMAIL_BULK_REPLACE: '/clientemail/bulk-replace',
});

const Enum = Object.freeze({
  SERVICE_TYPES: '/Enum/servicetypes',
  FILE_PRCS_STATUS: '/Enum/fileprocessingstatus',
});

const Report = Object.freeze({
  LIST: '/Report/list',
  LIST_CARDS: '/Report/list-cards',
  REPORT: '/Report',
  REPORT_FILES: '/Report/report-files',
  OVERRIDE_LIST: '/Report/override-list',
  DEFAULT_REPORT: '/Report/report-button-file-default/',
  GET_SURVEY_LETTERS: '/Report/get-survey-letters',
  GET_SURVEYS: '/Report/get-surveys',
  GET_SURVEY: '/Report/get-survey',
  GET_LETTER_SURVEY: '/Report/get-letter-survey',
  MONTH_END: '/Report/add/month-end',
  MONTH_END_LIST: '/Report/month-end-batches',
  MONTH_END_FILE: '/Report/get-month-end-file',
  CLIENT_SAMPLE: '/Report/report-client-sample',
  RESET_MONTH_END: '/Report/reset/month-end',
});

const File = Object.freeze({
  UPLOAD: '/File/upload/',
  REPORT: '/File/upload/report',
  RESULTS: '/File/processing-results/',
  ERRORS: '/File/processing-errors/',
  BATCHOUPLOAD: '/File/upload/batcho/',
  BATCHORESULTS: '/File/processing-results/batcho/',
  CREATERECORD: '/File/processing-results/Addnonexisting',
  CREATEALIAS: '/File/processing-results/Addalias',
});

const Location = Object.freeze({
  FULL_LIST: '/Location/list',
  LIST: '/Location/dropdown-list',
  GET_BY_CODE: '/Location/get-by-code',
  GET_BY_NAME: '/Location/get-by-name',
  ADD: '/Location/add',
  UPDATE: '/Location/update',
  DELETE: '/Location/delete',
});

const Group = Object.freeze({
  LIST_BY_CLIENT: '/Group/list-by-client',
  GET_BY_CODE: '/Group/get-by-code',
  GET_BY_NAME: '/Group/get-by-name',
  ADD: '/Group/add',
  UPDATE: '/Group/update',
  UPDATE_MULTIPLE: '/Group/update-multiple',
  DELETE: '/Group/delete',
});

const Role = Object.freeze({
  LIST: '/Role/list',
});

const SMaster = Object.freeze({
  RECORD: '/SMaster',
  LIST: '/SMaster/list',
  EXCEPTION: '/SMaster/exceptions-list',
  UPDATE: '/SMaster/update',
  DELETE: '/SMaster/delete',
  MOVE: '/SMaster/move',
});

const User = Object.freeze({
  UNLOCK: '/User/unlock',
  LIST: '/User/list',
  USER: '/User',
  ADD: '/User/add',
  UPDATE: '/User/update',
  DELETE: '/User/delete',

  SIGN_IN: '/User/sign-in',
  FORGOT_PWD: '/User/forgot-password',
  RESET_PWD: '/User/reset-password',
  CHANGE_PWD: '/User/change-password',
  RESENT_UNLOCK_EML: '/User/resend-unlock-email',
});

const Region = Object.freeze({
  DROPDOWN: '/Region/dropdown-list',
  LIST: '/Region/list',
  USER: '/Region',
  ADD: '/Region/add',
  UPDATE: '/Region/update',
  DELETE: '/Region/delete',
});

const Survey = Object.freeze({
  LIST: '/Survey/list',
  GET: '/Survey/get-by-smasterid',

  ADD_FUNERAL: '/Survey/add-funeral',
  ADD_CREMATION: '/Survey/add-cremation',
  ADD_CEMETARY: '/Survey/add-cemetary',
  ADD_MONUMENT: '/Survey/add-monument',
  ADD_PRE_NEED: '/Survey/add-pre-need',
  ADD_PET_CREMATION: '/Survey/add-pet-cremation',
  ADD_EVENT_PLANNING: '/Survey/add-event-planning',

  UPDATE_FUNERAL: '/Survey/update-funeral',
  UPDATE_CREMATION: '/Survey/update-cremation',
  UPDATE_CEMETARY: '/Survey/update-cemetary',
  UPDATE_MONUMENT: '/Survey/update-monument',
  UPDATE_PRE_NEED: '/Survey/update-pre-need',
  UPDATE_PET_CREMATION: '/Survey/update-pet-cremation',
  UPDATE_EVENT_PLANNING: '/Survey/update-event-planning',

  DELETE_FUNERAL: '/Survey/delete-funeral',
  DELETE_CREMATION: '/Survey/delete-cremation',
  DELETE_CEMETARY: '/Survey/delete-cemetary',
  DELETE_MONUMENT: '/Survey/delete-monument',
  DELETE_PRE_NEED: '/Survey/delete-pre-need',
  DELETE_PET_CREMATION: '/Survey/delete-pet-cremation',
  DELETE_EVENT_PLANNING: '/Survey/delete-event-planning',
});

const Question = Object.freeze({
  GET_BY_CSV: '/Question/get-by-csv',
});

const Department = Object.freeze({
  DROPDOWN: '/Department/dropdown-list',
  LIST: '/Department/list',
  ADD: '/Department/add',
  UPDATE: '/Department/update',
});

const OpportunityPlan = Object.freeze({
  GET_BY_ID: '/OpportunityPlan/get-by-clientid',
  RECORD: '/OpportunityPlan',
  LIST: '/OpportunityPlan/list',
  BONUSES: '/OpportunityPlan/bonuses',
  MISSING_PLANS: '/OpportunityPlan/add-missing-plans',
  MISSING_LOCATIONS: '/OpportunityPlan/add-missing-locations',
  MISSING_TARGETS: '/OpportunityPlan/add-missing-targets',
  ADD_LOCATION: '/OpportunityPlan/bonuses/locations/add',
  GET_LOCATIONS: '/OpportunityPlan/bonuses/locations',
  DELETE_LOCATION: '/OpportunityPlan/bonuses/locations/remove',
  GET_QUESTIONS_TO_ADD: '/OpportunityPlan/bonuses/questions',
  ADD_QUESTION: '/OpportunityPlan/bonuses/add',
  DELETE_QUESTION: '/OpportunityPlan/bonuses/delete',
  UPDATE_QUESTION: '/OpportunityPlan/bonuses/update',
  // ZERO-AR: '/OpportunityPlan/{opportunityPlanId}/zero-ar', // do not implement, but beware of it existing
  // LOCATIONS: '/OpportunityPlan/{opportunityPlanId}/locations', // do not implement, but beware of it existing
  // TARGETS: '/OpportunityPlan/{opportunityPlanId}/targets', // do not implement, but beware of it existing
  // EMPLOYEES: '/OpportunityPlan/{opportunityPlanId}/employees', // do not implement, but beware of it existing
  // RANGES: '/OpportunityPlan/{opportunityPlanId}/ranges', // do not implement, but beware of it existing
});

const Employee = Object.freeze({
  ADD: '/Employee/add',
  UPDATE: '/Employee/update',
  ADD_FD: '/Employee/add-from-arranger',
  FD_CLONE: '/Employee/clone-client-arrangers',
  DEPT_CLONE: '/Employee/clone-department',
  RECORD: '/Employee',
  DELETE: '/Employee/delete',
});

const Utility = Object.freeze({
  AR_ENTRY: '/Utility/ar-entry/',
});

const ServiceStatus = Object.freeze({
  LIST: '/ServiceStatus/list',
});

const Export = Object.freeze({
  GET_SURVEYS: '/Export/get-surveys',
  GET_SURVEYS_ALL: '/Export/get-surveys-all',
});

export {
  Client,
  Report,
  Role,
  User,
  Base,
  File,
  Enum,
  SMaster,
  Arranger,
  Group,
  Location,
  Batch,
  BatchO,
  Region,
  Survey,
  Department,
  SurveyPrints,
  OpportunityPlan,
  Employee,
  Question,
  Utility,
  ServiceStatus,
  Export,
};
